import {Injectable} from '@angular/core';
import {App, Platform, Tabs} from "ionic-angular";

import {Util} from '../app/util';

import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

import {DataService} from "../providers/data-service";
import {CLOSE_PAGE} from "../app/import";
import {CONFIG} from "../app/config";
import {LogadoService} from "../providers/logado-service";
import {DeviceDetectorService} from 'ngx-device-detector';
import {TLoginTipo} from '../app/enum';

@Injectable()
export class NavRepository {

    config: any;

    constructor(public util: Util, public dataService: DataService, public app: App,
                public platform: Platform,
                public logadoService: LogadoService,
                public deviceService: DeviceDetectorService) {

        this.config = CONFIG;

    }

    // NÃO PRECISA DE NAVCTRL E DATASERVICE, PODE IMPORTAR NO CONSTRUCTOR AQUI
    // não tem problema dos roots das tabs pq só é chamado via App, Login, Novo Cad.
    // edit: tentei trocar mas deu uns problemas, tentar novamente outra vez, com pelo menos this.dataService
    afterLogin(navCtrl: any, components): Observable<any> {


        return Observable.create((observer: Observer<any>) => {

            let logado = this.logadoService.getAuth();

            if (!logado) {
                // sempre vai para o Nav root
                navCtrl = navCtrl.parent || navCtrl; // Tabs or Tab
                navCtrl = navCtrl.parent || navCtrl; // Nav or Tabs
            }


            /** ******************************** DEVELOPER ******************************** **/
            /** *************************************************************************** **/

            if (this.dataService.get('param.force')) {

                if (!components[this.dataService.get('param.force')]) {
                    this.util.alertSimply('Force não encontrado');
                    return;
                }

                navCtrl.setRoot(components[this.dataService.get('param.force')]);
            }
            else if (this.dataService.get('param.index') != null) {
                this.selectOrCreateTab(navCtrl, components, this.dataService.get('param.index'));
            }

            else if (this.dataService.get('param.show') == 'hour') {
                navCtrl.setRoot(components.showhour);
            }
            else if (this.dataService.get('param.show') != null) {
                navCtrl.setRoot(components.showopen);
            }




            /** ******************************** SKYDIVE ********************************** **/
            /** *************************************************************************** **/

            // sem tabs / operação
            else if (this.dataService.get('param.page') == 'skydive') {
                navCtrl.setRoot(components.skydive);
            }
            else if (this.dataService.get('param.page') == 'pedido') {
                navCtrl.setRoot(components.pedido);
            }



            /** ****************************** LOREAN SHOW ******************************** **/
            /** *************************************************************************** **/

            else if (this.dataService.get('param.page') == 'webstor') {
                navCtrl.setRoot(components.webstor);
            }
            else if (this.dataService.get('param.page') == 'showview') {
                navCtrl.setRoot(components.showview, {etapa: 0, hotspotID: this.config.kairos.HotspotID});
            }
            else if (this.dataService.get('param.page') == 'showsync') {
                navCtrl.setRoot(components.showsync);
            }
            else if (this.dataService.get('param.page') == 'showdesk') {
                navCtrl.setRoot(components.showdesk);
            }
            else if (this.dataService.get('param.page') == 'showfila') {
                navCtrl.setRoot(components.showfila);
            }
            else if (this.dataService.get('param.page') == 'desktop') {
                navCtrl.setRoot(components.desktop);
            }
            else if (this.dataService.get('param.page') == 'myhot') {
                (window as any).handappMainInstance.hotpageCall();
            }




            /** ****************************** LOREAN PAGE ******************************** **/
            /** *************************************************************************** **/

            // roots de tabs, alguns com acesso direto sem tabs
            // não remover, exemplo de como fazer navegar sequencial dentro das abas
            // navCtrl.setRoot(components.tabsmenu, {index: 0, pushs: [{component: components.perfil, data: {}, options: {animate: false, direction: 'forward'}}]}, {animate: false, direction: 'forward'});

            else if (this.dataService.get('param.page') == 'meritum') {
                (window as any).handappMainInstance.meritumCall();
            }
            else if (this.dataService.get('param.page') == 'logado') {
                navCtrl.setRoot(components.logado);
            }
            else if (this.dataService.get('param.page') == 'perfil') {
                navCtrl.setRoot(components.profile);
            }
            else if (this.dataService.get('param.page') == 'password') {
                navCtrl.setRoot(components.password, {etapa: 0, loginTipo: TLoginTipo.loRegister, justLogin: true});
            }






            else if (this.deviceService.isTablet()) {
                navCtrl.setRoot(components.desktop, {etapa: 0});
            }


            /** ****************************** LOREAN MKIT ******************************** **/
            /** *************************************************************************** **/

            else if (CONFIG.isAmbiente(this.util, ['myweb'])) {
                (window as any).handappMainInstance.hotpageCall();
            }



            /** ******************************** LOREAN APP ******************************* **/
            /** *************************************************************************** **/
            else if (this.util.nativeApp() || this.util.develop()) {
                let home = !this.util.nativeApp() || this.platform.is('tablet') || CONFIG.data.device.DevicerNome == 'K2';
                if (!home) this.selectOrCreateTab(navCtrl, components, 1);
                if ( home) navCtrl.setRoot(components.siteolha, {etapa: 1});


                //navCtrl.setRoot(components.tabsmenu, {}, {animate: true, direction: 'forward'});
            }



            /** ******************************** LOREAN WEB ******************************* **/
            /** *************************************************************************** **/
            else if (this.dataService.get('param') != null) {
                console.log(this.dataService.get('param'));
            }
            else {
                let home = !this.util.nativeApp() || this.platform.is('tablet') || CONFIG.data.device.DevicerNome == 'K2';
                if (!home) this.selectOrCreateTab(navCtrl, components, 1);
                if ( home) navCtrl.setRoot(components.siteolha, {etapa: 1});
            }

            observer.complete();

        });

    }

    // Tabs | Tab | Nav | NavController
    afterLogout(navCtrl: any, components): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            if (!navCtrl) alert('ELLZITO ERRO DEVELOP');

            // sempre vai para o Nav root
            navCtrl = navCtrl.parent || navCtrl; // Tabs or Tab
            navCtrl = navCtrl.parent || navCtrl; // Nav or Tabs



            /** ******************************** DEVELOPER ******************************** **/
            /** *************************************************************************** **/

            if (this.dataService.get('param.force')) {
                navCtrl.setRoot(components[this.dataService.get('param.force')]);
            }

            else if (this.dataService.get('param.show') != null) {
                navCtrl.setRoot(components.showopen);
            }


            /** ******************************** HOTSITE ********************************** **/
            /** *************************************************************************** **/

            else if (CONFIG.isAmbiente(this.util, ['myweb'])) {
                (window as any).handappMainInstance.hotpageCall();
            }


            /** ******************************** SKYDIVE ********************************** **/
            /** *************************************************************************** **/

            // sem tabs / operação
            else if (this.dataService.get('param.page') == 'skydive') {
                navCtrl.setRoot(components.skydive);
            }
            else if (this.dataService.get('param.page') == 'pedido') {
                navCtrl.setRoot(components.pedido, {etapa: 0});
            }



            /** ****************************** LOREAN PAGE ******************************** **/
            /** *************************************************************************** **/

            // roots de tabs, alguns com acesso direto sem tabs
            // não remover, exemplo de como fazer navegar sequencial dentro das abas
            // navCtrl.setRoot(components.tabsmenu, {index: 0, pushs: [{component: components.profile, data: {}, options: {animate: false, direction: 'forward'}}]}, {animate: false, direction: 'forward'});

            else if (this.dataService.get('param.page') == 'meritum') {
                (window as any).handappMainInstance.meritumCall();
            }
            else if (this.dataService.get('param.page') == 'register') {
                navCtrl.setRoot(components.register);
            }
            else if (this.dataService.get('param.page') == 'password') {
                navCtrl.setRoot(components.password, {etapa: 0, loginTipo: TLoginTipo.loRegister, justLogin: true});
            }
            else if (this.dataService.get('param.page') == 'showsync') {
                navCtrl.setRoot(components.showsync);
            }
            else if (this.dataService.get('param.page') == 'showdesk') {
                navCtrl.setRoot(components.showdesk);
            }
            else if (this.dataService.get('param.page') == 'showfila') {
                navCtrl.setRoot(components.showfila);
            }
            else if (this.dataService.get('param.page') == 'showview') {
                navCtrl.setRoot(components.showview, {etapa: 0, hotspotID: this.config.kairos.HotspotID});
            }
            else if (this.dataService.get('param.page') == 'myhot') {
                (window as any).handappMainInstance.hotpageCall();
            }


            else if (this.deviceService.isTablet() || this.dataService.get('param.page') == 'ipad' || this.dataService.get('DEVICER-IPAD')) {
                navCtrl.setRoot(components.desktop, {etapa: 0});
            }
            else {
                let home = !this.util.nativeApp() || this.platform.is('tablet') || CONFIG.data.device.DevicerNome == 'K2';
                if (!home) navCtrl.setRoot(components.register);
                if ( home) navCtrl.setRoot(components.siteolha, {etapa: 1});
            }

            observer.complete();

        });

    }

    closePop(navCtrl: any, forceClose: boolean = false) {

        if (navCtrl.canGoBack() && !forceClose) navCtrl.pop();
        else this.closePage(navCtrl, CLOSE_PAGE).subscribe();

    }

    closePage(navCtrl: any, components): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            if (!navCtrl) {
                observer.complete();
                return;
            }

            // myweb
            if (CONFIG.isAmbiente(this.util, ['myweb'])) {
                if (navCtrl.parent && navCtrl.parent._componentName == 'tabs') {
                    navCtrl.popToRoot({animate: true, direction: 'back'});
                }
                else {
                    navCtrl.setRoot(components.tabsmenu, {}, {animate: true, direction: 'back'});
                }
            }

            // app do lorean ou das casas
            else if (!this.dataService.get('param.page')) {
                navCtrl.popToRoot({animate: true, direction: 'back'});
                //navCtrl.setRoot(components.tabsmenu, {}, {animate: true, direction: 'back' });
            }

            observer.complete();

        });

    }

    private selectOrCreateTab(navCtrl, components, index): void {

        if (this.app.getRootNavs()[0].getActiveChildNavs().length) {
            let tabs: Tabs = this.app.getRootNavs()[0].getActiveChildNavs()[0];
            tabs.select(index);
        }
        else {
            navCtrl.setRoot(components.tabsmenu, {index: index});
        }

    }

}



// WEBPACK FOOTER //
// ./src/repositories/nav-repository.ts